import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/java': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M277.7 312.9c-94.5 24.9-277 13.3-224.5-12.1 44.5-21.4 80.6-19 80.6-19s-93.1 22.1-33 30.1c25.4 3.4 76 2.6 123.1-1.3 38.5-3.2 77.2-10.2 77.2-10.2s-13.6 5.8-23.4 12.5zM192.3 280.8c-48.5-43.8-84.1-82.3-60.2-118.2 35.1-52.5 132.2-78.1 110.7-162.6 0 0 53.2 53.2-50.5 135-83.1 65.6-19 103.1 0 145.8zM306.9 104.6c-111.6 64.7-91 83.5-64.1 121.3 28.8 40.5-33.9 72.9-33.9 72.9s31.2-25.6 6.5-54c-83.7-96.4 91.6-140.2 91.5-140.2zM300.8 375.1c96.1-49.9 51.6-97.9 20.6-91.4-3.1 0.6-8 1.9-11 3 1.7-2.4 5.4-5.3 8.2-6.3 61.3-21.6 108.5 63.6-19.8 97.3 0.6-0.6 1.5-1.8 2-2.6zM348 437.4c53 23.9-115.2 72-319.4 38.8-74.9-12.1 36.1-54.5 56.4-40.2 0 0-6.5-0.4-17.7 2-10.8 2.3-45.1 13.4-26.8 21.3 50.8 22.1 233.7 16.8 291.6-0.7 30.4-9.3 15.9-21.2 15.9-21.2zM124.4 396c0 0-19.6 11.4 13.9 15.2 40.6 4.6 61.3 4 106-4.5 7.5 4.5 20.1 10.7 28.2 13.8-100.2 42.9-226.8-2.5-148.1-24.5zM304.2 493.2c69.8-13.2 76.2-29.7 76.2-29.7-3.3 43.6-144.9 52.8-237.1 46.9-60.6-3.9-72.4-13.7-72.4-13.6 57.5 9.5 154.6 11.2 233.3-3.6zM260.6 353c5.1 4.7 14.5 10.5 21.1 12.8-121.3 35.5-256.3 2.9-169.5-25.9 0 0-21.9 16.2 11.6 19.7 43.3 4.5 77.6 4.8 136.8-6.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/java.js
// module id = 894
// module chunks = 0